import React from 'react';

import styled, {css} from 'styled-components';

import BaseButton from '../Button';
import {TInputProps as TMixinsInputProps, mixins} from '../styles';

export const TextInput = styled.div`
  position: relative;
`;

type TInputProps = React.InputHTMLAttributes<HTMLInputElement> & TMixinsInputProps;

export const Input = styled.input<TInputProps>`
  ${mixins.input}
  ${mixins.truncate}
  cursor: text;
  ${({theme}) => css`
    ${theme.typography?.input ? mixins[theme.typography?.input] : ''}
    line-height: ${theme.dimensions.controlHeightM}px;
  `}
`;

type TChildrenProps = {
  left?: boolean;
  right?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
};

export const Children = styled.div<TChildrenProps>`
  ${mixins.flexAlign('center')}
  ${({theme, left, right, readOnly}) => css`
    ${mixins.position({
      position: 'absolute',
      right: right ? theme.spacing.s3 : undefined,
      left: left ? theme.spacing.s3 : undefined,
      top: '50%',
    })}
    ${readOnly &&
    css`
      cursor: default;
    `}
  `}
  transform: translate(0, -50%);
  pointer-events: none;
  > * {
    pointer-events: auto;
  }
`;

export const Icon = styled.svg`
  ${mixins.wh('16px')}
`;

export const Button = styled(BaseButton).attrs({square: true})`
  background: none;
  border: none;
  box-shadow: none;
`;
